<template>
  <div
    class="table-responsive border-0 border-radius-sm w-100 mb-3"
    style="background-color: rgb(220, 220, 220)"
  >
    <table class="table align-items-center mb-1">
      <thead>
        <tr>
          <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 ps-2">Recipe name</th>
          <th
            class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
            style="max-width: 100px"
          >
            Last update
          </th>
          <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Gun name</th>
          <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
            Current Setting at PLC
          </th>
          <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">New Setting</th>
          <th
            v-if="hasReductionFactor1"
            class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
          >
            Reduction Factor 1
          </th>
          <th
            v-if="hasReductionFactor2"
            class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
          >
            Reduction Factor 2
          </th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td style="word-break: break-word; white-space: normal; max-width: 180px">
            <h6
              class="text-sm text-secondary mb-0"
              style="word-break: break-word; white-space: normal"
            >
              {{ recipeName }}
            </h6>
          </td>
          <td
            class="align-middle text-center"
            style="max-width: 90px; vertical-align: middle"
          >
            <span
              class="text-secondary text-sm justify-content-center align-items-center"
              style="word-break: break-word; white-space: normal; display: block"
            >
              {{ updatedAt }}
            </span>
          </td>
          <td class="align-middle text-center p-0">
            <table class="table table-sm mb-0 w-100 table-bordered">
              <tbody>
                <tr
                  v-for="[gun_id, gun_name] in Object.entries(gunNamesByGunId)"
                  :key="gun_id"
                >
                  <td class="text-secondary text-sm w-100">
                    <b>{{ gun_name }}</b>
                  </td>
                </tr>
              </tbody>
            </table>
          </td>
          <td class="align-middle text-center p-0">
            <table class="table table-sm mb-0 w-100 table-bordered">
              <tbody>
                <tr
                  v-for="[gun_id] in Object.entries(gunNamesByGunId)"
                  :key="gun_id"
                >
                  <td class="text-secondary text-sm w-100">
                    {{
                      currentPowderAmountSettingByGunId[gun_id]
                        ? parseFloat(currentPowderAmountSettingByGunId[gun_id].toFixed(2))
                        : "-"
                    }}
                  </td>
                </tr>
              </tbody>
            </table>
          </td>
          <td class="align-middle text-center p-0">
            <table class="table table-sm mb-0 w-100 table-bordered">
              <tbody>
                <tr
                  v-for="[gun_id] in Object.entries(gunNamesByGunId)"
                  :key="gun_id"
                >
                  <td class="text-secondary text-bold text-sm w-100">
                    {{
                      newPowderAmountSettingByGunId[gun_id]
                        ? parseFloat(newPowderAmountSettingByGunId[gun_id].toFixed(1))
                        : "-"
                    }}
                  </td>
                </tr>
              </tbody>
            </table>
          </td>
          <td
            v-if="hasReductionFactor1"
            class="align-middle text-center p-0"
          >
            <table class="table table-sm mb-0 w-100 table-bordered">
              <tbody>
                <tr
                  v-for="[gun_id] in Object.entries(gunNamesByGunId)"
                  :key="gun_id"
                >
                  <td class="text-secondary text-bold text-sm w-100">
                    {{ newReductionFactor1ByGunId[gun_id] != null ? newReductionFactor1ByGunId[gun_id] : "-" }}
                  </td>
                </tr>
              </tbody>
            </table>
          </td>
          <td
            v-if="hasReductionFactor2"
            class="align-middle text-center p-0"
          >
            <table class="table table-sm mb-0 w-100 table-bordered">
              <tbody>
                <tr
                  v-for="[gun_id] in Object.entries(gunNamesByGunId)"
                  :key="gun_id"
                >
                  <td class="text-secondary text-bold text-sm w-100">
                    {{ newReductionFactor2ByGunId[gun_id] != null ? newReductionFactor2ByGunId[gun_id] : "-" }}
                  </td>
                </tr>
              </tbody>
            </table>
          </td>
        </tr>
      </tbody>
    </table>
    <div class="d-flex w-95 mt-4 ps-3 align-items-center">
      <button
        class="btn btn-info flex-fill me-2 py-2 px-2 btn-sm"
        type="button"
        @click="dismissSettings()"
      >
        DON'T SEND (DISMISS)
      </button>
      <button
        :class="`btn flex-fill ms-2 py-2 px-2 btn-sm ${isSendDisabled ? 'btn-secondary' : 'btn-success'}`"
        type="button"
        :disabled="isSendDisabled"
        @click="sendSettingsToPLC()"
      >
        {{ isSendDisabled ? "SEND SETTINGS DISABLED (no connection)" : "SEND SETTINGS TO PLC" }}
      </button>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { removeNullEntriesFromObject } from "@/views/composables.js";

export default {
  name: "SendRecipesRecipeCard",
  props: {
    recipeId: {
      type: String,
      default: "",
    },
    recipeName: {
      type: String,
      default: "",
    },
    updatedAt: {
      type: String,
      default: "",
    },
    currentPowderAmountSettingByGunId: {
      type: Object,
      default: () => ({}),
    },
    newPowderAmountSettingByGunId: {
      type: Object,
      default: () => ({}),
    },
    newPowderAmountSettingIdByGunId: {
      type: Object,
      default: () => ({}),
    },
    gunNamesByGunId: {
      type: Object,
      default: () => ({}),
    },
    newReductionFactor1ByGunId: {
      type: Object,
      default: () => ({}),
    },
    newReductionFactor2ByGunId: {
      type: Object,
      default: () => ({}),
    },
  },
  emits: ["reload-data"],
  data() {
    return {};
  },
  computed: {
    isSendDisabled() {
      const values = Object.values(this.currentPowderAmountSettingByGunId);
      return values.length === 0 || values.every(v => v === null);
    },
    hasReductionFactor1() {
      return Object.values(this.newReductionFactor1ByGunId).some(v => v != null);
    },
    hasReductionFactor2() {
      return Object.values(this.newReductionFactor2ByGunId).some(v => v != null);
    },
  },
  methods: {
    removeNullEntriesFromObject,
    async sendSettingsToPLC() {
      const result = await this.$swal({
        title: "Are you sure?",
        text: "This will overwrite existing settings.",
        icon: "warning",
        showCancelButton: true,
        cancelButtonText: "Cancel",
        confirmButtonText: "Yes, send new settings",
        customClass: {
          confirmButton: "btn btn-success w-40 px-1 m-2",
          cancelButton: "btn bg-gradient-secondary w-40 px-1 m-2",
        },
        reverseButtons: true,
        buttonsStyling: false,
      });

      if (result.isConfirmed) {
        this.$store.state.isLoading = true;
        console.log("Sending settings to PLC for recipe:", this.recipeId);

        const powder_amount_setting_id_by_gun_id_filtered = this.removeNullEntriesFromObject(
          this.newPowderAmountSettingIdByGunId,
        );
        try {
          const response = await axios.patch("api/v1/steelcase/send-settings-to-plcs/", {
            recipe_id: this.recipeId,
            powder_amount_setting_id_by_gun_id: powder_amount_setting_id_by_gun_id_filtered,
          });
          this.$store.state.isLoading = false;

          const warnings = response.data.warnings;
          if (warnings && warnings.length > 0) {
            this.$swal({
              title: "Partial Success",
              text: "FLOW settings were sent successfully, but some issues occurred:\n\n" +
                warnings.map(w => `• ${w}`).join("\n"),
              icon: "warning",
              confirmButtonText: "OK",
              customClass: {
                confirmButton: "btn btn-warning w-40 px-1 m-2",
              },
            }).then(() => {
              this.$emit("reload-data");
            });
          } else {
            this.$swal({
              title: "Success",
              text: "Settings sent to PLC successfully.",
              icon: "success",
              confirmButtonText: "OK",
              customClass: {
                confirmButton: "btn btn-success w-40 px-1 m-2",
              },
            }).then(() => {
              this.$emit("reload-data");
            });
          }
        } catch (error) {
          this.$store.state.isLoading = false;
          this.$swal({
            title: "Error",
            text: "Failed to send settings to PLC.",
            icon: "error",
            confirmButtonText: "OK",
            customClass: {
              confirmButton: "btn btn-danger w-40 px-1 m-2",
            },
          });
        }
      }
    },
    async dismissSettings() {
      const result = await this.$swal({
        title: `Are you sure you want to dismiss / ignore new settings for recipe "${this.recipeName}"?`,
        text: "This action will dismiss the new settings and the recipe will not appear in this page until the next update.",
        icon: "info",
        showCancelButton: true,
        cancelButtonText: "Cancel",
        confirmButtonText: "Yes, mark as updated",
        customClass: {
          confirmButton: "btn btn-info w-40 px-1 m-2",
          cancelButton: "btn bg-gradient-secondary w-40 px-1 m-2",
        },
        reverseButtons: true,
        buttonsStyling: false,
      });
      if (result.isConfirmed) {
        console.log("Marking recipe as updated manually:", this.recipeId);

        const powder_amount_setting_id_by_gun_id_filtered = this.removeNullEntriesFromObject(
          this.newPowderAmountSettingIdByGunId,
        );

        const response = await axios.patch("api/v1/steelcase/dismiss-settings/", {
          powder_amount_setting_id_by_gun_id: powder_amount_setting_id_by_gun_id_filtered,
        });
        if (response.status === 200) {
          this.$swal({
            title: "Success",
            text: "Recipe dismissed. You won't see this recipe again until it is updated.",
            icon: "success",
            confirmButtonText: "OK",
            customClass: {
              confirmButton: "btn btn-success w-40 px-1 m-2",
            },
          }).then(() => {
            this.$emit("reload-data");
          });
        } else {
          this.$swal({
            title: "Error",
            text: "Failed to mark recipe as updated manually.",
            icon: "error",
            confirmButtonText: "OK",
            customClass: {
              confirmButton: "btn btn-danger w-40 px-1 m-2",
            },
          });
        }
      }
    },
  },
};
</script>
